import { useQuery } from '@tanstack/react-query';
import { filtersApi } from '../../lib/api/filters';
import { useAuth } from '../auth/AuthContext';

/**
 * Onboarding has 3 steps (empresa, região, palavras-chave). Steps 1-2 are stored on the
 * company; step 3 is "has at least one filter". Checked once per session (cached by
 * react-query) rather than tracked as a separate flag, since the API has none.
 */
export function useOnboardingStatus() {
  const { user } = useAuth();
  const filtersQuery = useQuery({
    queryKey: ['filters'],
    queryFn: () => filtersApi.list().then((res) => res.data),
    enabled: Boolean(user),
    staleTime: 30_000,
  });

  const companyDone = Boolean(user?.company?.segment) && (user?.company?.states_of_interest.length ?? 0) > 0;
  const isLoading = Boolean(user) && filtersQuery.isLoading;
  const isComplete = companyDone && (filtersQuery.data?.length ?? 0) > 0;

  return { isLoading, isComplete };
}
